import { UseFormReturnType, isNotEmpty, useForm } from '@mantine/form'
import { modals } from '@mantine/modals'
import { notifications } from '@mantine/notifications'

import {
  useAddEmailDomainToUserMutation,
  useGetEmailDomainsQuery,
} from '../api/emailDomain.api'
import { IAddEmailDomainToUser } from '../emailDomain.types'

export interface IAddEmailDomianUseCase {
  form: UseFormReturnType<IAddEmailDomainToUser>
  onSubmit: () => void
  isLoading: boolean
  catalogEmailDomains: { label: string; value: string }[]
}

const addEmailDomainToUserUseCase = (): IAddEmailDomianUseCase => {
  const [addEmailDomainMutation, { isLoading }] =
    useAddEmailDomainToUserMutation()
  const { data: emailDomains } = useGetEmailDomainsQuery()

  const form = useForm<IAddEmailDomainToUser>({
    mode: 'uncontrolled',
    initialValues: {
      membershipId: '',
      name: '',
      type: 'SEND',
      emailDomainId: '',
      signatureTemplate: '',
    },
    validateInputOnBlur: true,
    validate: {
      membershipId: isNotEmpty('Domain is required!'),
      name: isNotEmpty('Name is required!'),
      emailDomainId: isNotEmpty('Email domain is required!'),
      signatureTemplate: isNotEmpty('Email Signature is required!'),
    },
  })

  const onSubmit = () => {
    form.onSubmit(async (values) => {
      addEmailDomainMutation(values)
        .unwrap()
        .then(() => {
          modals.closeAll()
          notifications.show({
            title: 'Success',
            message: 'Email domain successfully added',
          })
        })
        .catch(() => {
          notifications.show({
            title: 'Error',
            message: 'There was an error to add email domain',
            color: 'red',
          })
        })
    })()
  }

  return {
    form,
    onSubmit,
    isLoading,
    catalogEmailDomains: !!emailDomains?.length
      ? emailDomains.map((emailDomain) => ({
          label: emailDomain.domain,
          value: emailDomain.id,
        }))
      : [],
  }
}

export default addEmailDomainToUserUseCase
